// extracted by mini-css-extract-plugin
export default {"mainTitle":"Summary_mainTitle__3790A","divider":"Summary_divider__tkKEb"};